/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"
import * as Apollo from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { RoomChildrenFragmentDoc, RoomFragmentDoc } from "./fragments.generated"

type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

const defaultOptions = {} as const
export type CreateRoomInput = {
  airVolumePerArea?: number | null
  airVolumePerPerson?: number | null
  area?: number | null
  eha?: number | null
  eta?: number | null
  height?: number | null
  id: string
  ida?: number | null
  label?: string | null
  number: string
  oda?: number | null
  personsNumber?: number | null
  position?: number | null
  rca?: number | null
  remark?: string | null
  sec?: number | null
  soundPressureLevel?: number | null
  sup?: number | null
  tra?: number | null
  utilization?: string | null
  volume?: number | null
}

export type JsonapiRelationshipData = {
  id: string
  type: string
}

export type UpdateRoomInput = {
  airVolumePerArea?: number | null
  airVolumePerPerson?: number | null
  area?: number | null
  eha?: number | null
  eta?: number | null
  height?: number | null
  id: string
  ida?: number | null
  label?: string | null
  number?: string | null
  oda?: number | null
  parent?: JsonapiRelationshipData | null
  personsNumber?: number | null
  position?: number | null
  rca?: number | null
  remark?: string | null
  sec?: number | null
  soundPressureLevel?: number | null
  sup?: number | null
  tra?: number | null
  utilization?: string | null
  volume?: number | null
}

export type CreateRoomMutationVariables = Exact<{
  input: Types.CreateRoomInput
  parentType: string
  parentID: string
}>

export type CreateRoomMutation = {
  __typename: "Mutation"
  room: {
    __typename: "Room"
    id: string
    label?: string | null
    number: string
    area?: number | null
    volume?: number | null
    utilization?: string | null
    height?: number | null
    personsNumber?: number | null
    airVolumePerArea?: number | null
    airVolumePerPerson?: number | null
    remark?: string | null
    sup?: number | null
    oda?: number | null
    eta?: number | null
    eha?: number | null
    tra?: number | null
    rca?: number | null
    ida?: number | null
    sec?: number | null
    soundPressureLevel?: number | null
    position: number
    createdAt: string
    updatedAt: string
    hasClarificationRequest?: boolean | null
    children?: Array<{
      __typename: "ProductPosition"
      id: string
      label?: string | null
      variantKey: string
      configurationKey?: string | null
      remark?: string | null
      quantity: number
      position: number
      displayPosition?: string | null
      isAlternative?: boolean | null
      price?: number | null
      priceGroup?: string | null
      hasClarificationRequest?: boolean | null
      references?: Array<{
        __typename: "ProductPositionInstallationReference"
        id: string
        title?: string | null
        permalink: string
        position: number
      }> | null
      addons?: Array<{
        __typename: "ProductPositionAddon"
        id: string
        variantKey: string
        parentProductType: string
      }> | null
      dimensioning?: {
        __typename: "ExternalDimensioningResult"
        transactionId: string
        environmentalVars?: Array<any> | null
        variantKeyData?: any
        dllVersion?: string | null
        language?: string | null
        technicalData?: Array<
          | {
              __typename: "ExternalDimensioningTechnicalDataDllVersion"
              dllVersion: string
            }
          | {
              __typename: "ExternalDimensioningTechnicalDataTable"
              header?: Array<string> | null
              content?: any
              summary?: string | null
              type?: string | null
            }
        > | null
        technicalInput?: Array<{
          __typename: "ExternalDimensioningTechnicalInput"
          name: string
          label?: string | null
          unit?: string | null
          value?: any
          userSelected: boolean
        }> | null
        supplementaryText?: Array<{
          __typename: "ExternalDimensioningSupplementaryText"
          text: string
        }> | null
        transferData?: {
          __typename: "ExternalDimensioningTransferData"
          origin?: string | null
        } | null
      } | null
    }> | null
  }
}

export type UpdateRoomMutationVariables = Exact<{
  id: string
  input: Types.UpdateRoomInput
}>

export type UpdateRoomMutation = {
  __typename: "Mutation"
  room: {
    __typename: "Room"
    id: string
    label?: string | null
    number: string
    area?: number | null
    volume?: number | null
    utilization?: string | null
    height?: number | null
    personsNumber?: number | null
    airVolumePerArea?: number | null
    airVolumePerPerson?: number | null
    remark?: string | null
    sup?: number | null
    oda?: number | null
    eta?: number | null
    eha?: number | null
    tra?: number | null
    rca?: number | null
    ida?: number | null
    sec?: number | null
    soundPressureLevel?: number | null
    position: number
    createdAt: string
    updatedAt: string
    hasClarificationRequest?: boolean | null
  }
}

export type DeleteRoomMutationVariables = Exact<{
  id: string
}>

export type DeleteRoomMutation = {
  __typename: "Mutation"
  room: { __typename: "DeleteResponse"; success: boolean }
}

export const CreateRoomDocument = gql`
  mutation CreateRoom(
    $input: CreateRoomInput!
    $parentType: String!
    $parentID: String!
  ) {
    room: createRoom(
      input: $input
      parentType: $parentType
      parentID: $parentID
    )
      @rest(
        type: "Room"
        method: "POST"
        endpoint: "room"
        path: "/project-list/{args.parentType}/{args.parentID}/children"
        bodySerializer: "room"
      ) {
      ...Room
      ...RoomChildren
    }
  }
  ${RoomFragmentDoc}
  ${RoomChildrenFragmentDoc}
`
export type CreateRoomMutationFn = Apollo.MutationFunction<
  CreateRoomMutation,
  CreateRoomMutationVariables
>

/**
 * __useCreateRoomMutation__
 *
 * To run a mutation, you first call `useCreateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRoomMutation, { data, loading, error }] = useCreateRoomMutation({
 *   variables: {
 *      input: // value for 'input'
 *      parentType: // value for 'parentType'
 *      parentID: // value for 'parentID'
 *   },
 * });
 */
export function useCreateRoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateRoomMutation,
    CreateRoomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateRoomMutation, CreateRoomMutationVariables>(
    CreateRoomDocument,
    options
  )
}
export type CreateRoomMutationHookResult = ReturnType<
  typeof useCreateRoomMutation
>
export type CreateRoomMutationResult = Apollo.MutationResult<CreateRoomMutation>
export type CreateRoomMutationOptions = Apollo.BaseMutationOptions<
  CreateRoomMutation,
  CreateRoomMutationVariables
>
export const UpdateRoomDocument = gql`
  mutation UpdateRoom($id: ID!, $input: UpdateRoomInput!) {
    room: updateRoom(id: $id, input: $input)
      @rest(
        type: "Room"
        method: "PUT"
        endpoint: "room"
        path: "/project-list/rooms/{args.id}"
        bodySerializer: "room"
      ) {
      ...Room
    }
  }
  ${RoomFragmentDoc}
`
export type UpdateRoomMutationFn = Apollo.MutationFunction<
  UpdateRoomMutation,
  UpdateRoomMutationVariables
>

/**
 * __useUpdateRoomMutation__
 *
 * To run a mutation, you first call `useUpdateRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRoomMutation, { data, loading, error }] = useUpdateRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateRoomMutation,
    UpdateRoomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<UpdateRoomMutation, UpdateRoomMutationVariables>(
    UpdateRoomDocument,
    options
  )
}
export type UpdateRoomMutationHookResult = ReturnType<
  typeof useUpdateRoomMutation
>
export type UpdateRoomMutationResult = Apollo.MutationResult<UpdateRoomMutation>
export type UpdateRoomMutationOptions = Apollo.BaseMutationOptions<
  UpdateRoomMutation,
  UpdateRoomMutationVariables
>
export const DeleteRoomDocument = gql`
  mutation DeleteRoom($id: ID!) {
    room: deleteRoom(id: $id)
      @rest(
        type: "DeleteResponse"
        method: "DELETE"
        endpoint: "delete"
        path: "/project-list/rooms/{args.id}?recursive=true"
      ) {
      success
    }
  }
`
export type DeleteRoomMutationFn = Apollo.MutationFunction<
  DeleteRoomMutation,
  DeleteRoomMutationVariables
>

/**
 * __useDeleteRoomMutation__
 *
 * To run a mutation, you first call `useDeleteRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomMutation, { data, loading, error }] = useDeleteRoomMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteRoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRoomMutation,
    DeleteRoomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<DeleteRoomMutation, DeleteRoomMutationVariables>(
    DeleteRoomDocument,
    options
  )
}
export type DeleteRoomMutationHookResult = ReturnType<
  typeof useDeleteRoomMutation
>
export type DeleteRoomMutationResult = Apollo.MutationResult<DeleteRoomMutation>
export type DeleteRoomMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoomMutation,
  DeleteRoomMutationVariables
>
